import { Container, Box } from "@mui/material";
import Logo from "../styles/logo.svg";
import Image from "../styles/register.jpg";

const UnauthenticatedLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Box
        sx={{
          backgroundImage: `url(${Image})`,
          backgroundSize: "cover",
          width: { xs: "100%", sm: "50%" },
          minHeight: { xs: 200, sm: "100vh" },
          bgcolor: "primary.dark",
          flexShrink: 0,
          "&:hover": {
            bgcolor: "primary.main",
            opacity: [0.9, 0.8, 0.7],
          },
        }}
      >
        <img src={Logo} alt="" style={{ width: 120, padding: 10 }} />
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "50%" }, flexShrink: 0 }}>
        <Container sx={{ height: "100vh" }}>{children}</Container>
      </Box>
    </Box>
  );
};

export default UnauthenticatedLayout;
